module.exports = __webpack_public_path__ + "static/ACT-7397d1df87f551b3c48b8ce52d2224fd.svg";